import { Component, Input } from '@angular/core';
import { AnalyticsActionTypes } from '@analytics/models';
import { FunctionalErrorItemRendering } from '@functional-errors/models';
import {
  InformationBlockComponent,
  InfoCardComponent,
} from '@legacy/common-ui-utility-components';
import { OpenModalDirective } from '@innogy/common-ui-modals';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackErrorDirective } from '@analytics/events';

@Component({
  selector: 'wl-functional-error[analyticsImpressionName]',
  templateUrl: './functional-error.component.html',
  standalone: true,
  imports: [
    InformationBlockComponent,
    OpenModalDirective,
    AutomationIdDirective,
    TrackErrorDirective,
    InfoCardComponent,
  ],
})
export class FunctionalErrorComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() errorItem?: FunctionalErrorItemRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() componentName = 'defaultComponent';

  /**
   * Indicates where the component is placed on the page vertically for analytics purposes.
   * RowContext has priority over this value.
   * If the component is placed in a row context, the position of the row is used.
   * If not, this value will be used. Can be found in sitecore rendering (rendering.position)
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() analyticsRootComponentPosition = 0;

  /**
   * used to indicate the name which is used in the content block impression event
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() analyticsImpressionName = 'default';

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId = 'default';

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() AnalyticsActionTypes = AnalyticsActionTypes;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() backgroundGrey = false;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() shadow = true;

  get rendering(): FunctionalErrorItemRendering | undefined {
    if (this.errorItem) {
      return {
        ...this.errorItem,
        componentName: this.componentName,
        position: this.analyticsRootComponentPosition,
      };
    }
    return undefined;
  }
}
